import React from "react";
import Skeleton from "react-loading-skeleton";
function SingleSkeleton() {
  return (
    <div
      className="relative gap-2 flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
      draggable="true"
    >
      <div>
        <Skeleton width={55} height={20} style={{ borderRadius: "9999px" }} />
      </div>
      <div>
        <Skeleton width={230} height={10} />
        <Skeleton width={150} height={10} />
      </div>
      <div>
        <Skeleton width={80} height={8} />
      </div>
    </div>
  );
}

export default function ProjectLoader() {
  return (
    <>
      <SingleSkeleton />
      <SingleSkeleton />
      <SingleSkeleton />
    </>
  );
}
